/*eslint-disable */
// import GPathSessionModel from '../../Model/GPathSession'
import request from '../../Utils/curl'
import axios from 'axios';

let GPathSessions = {
  /**
   * gpath_sessionList
   */
  async gpath_sessionList (context, whereFilter=null) {
    try{
      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "gpath_session_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at gpath_sessionList() and Exception:',err.message)
    }
  },

  /**
   * gpath_sessionView
   */
  async gpath_sessionView (context, gpathSessionId=null, gpathSessionData) {
    try {      
      let post_data = new FormData();

      if(gpathSessionData && gpathSessionData.student_id) {
        post_data.append('student_id', gpathSessionData.student_id);  
      }

      if(gpathSessionId) {
        post_data.append('gps_id', gpathSessionId);
      }
      
      if (gpathSessionData && gpathSessionData.latest_incomplete_session) {
        post_data.append('latest_incomplete_session', gpathSessionData.latest_incomplete_session);
      }

      if (gpathSessionData && gpathSessionData.pdt_id) {
        post_data.append('pdt_id', gpathSessionData.pdt_id);
      }
      
      return await request.curl(context, "gpath_session_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at gpath_sessionView() and Exception:",err.message)
    }    
  },

  /**
   * gpath_sessionAdd
   */
  async gpath_sessionAdd (context, gpath_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpath_sessionObj) {
        post_data.append(key, gpath_sessionObj[key]);
      }

      return await request.curl(context, "gpath_session_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpath_sessionAdd() and Exception:',err.message)
    }
  },

  /**
   * gpath_sessionEdit
   */
  async gpath_sessionEdit (context, gpath_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpath_sessionObj) {
        post_data.append(key, gpath_sessionObj[key]);
      }

      return await request.curl(context, "gpath_session_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpath_sessionEdit() and Exception:',err.message)
    }
  },

  /**
   * gpath_sessionDelete
   */
  async gpath_sessionDelete (context, gpathSessionId) {
    try{
      let post_data = new FormData();
      
      post_data.append('gps_id', gpathSessionId);

      return await request.curl(context, "gpath_session_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at gpath_sessionDelete() and Exception:',err.message)
    }
  },

  /**
   * gpath_session_report_generate
   */
  async gpath_session_report_generate (context, data, useLambda=false) {
    try{
      let post_data = new FormData();
      
      for (let key in data) {
        post_data.append(key, data[key]);
      }

      let api_url = process.env.VUE_APP_GPATHS_SERVICE
      if (useLambda) {
        api_url = process.env.VUE_APP_GPATHS_SERVER
      }

      return await request.curl(context, "generate_pdf", post_data, api_url)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at gpath_session_report_generate() and Exception:',err.message)
    }
  },

  /**
   * gpath_session_report_generate_lambda
   */
  async gpath_session_report_generate_lambda (context, data) {
    let CLOUD_IS_AWS = true
    if (CLOUD_IS_AWS) {
      // Redirected to gpath_session_report_generate during GCP to AWS migration
      return await gpath_session_report_generate(context, data)
    }

    let max_retries = 3, attempt = 1, wait_for = 10 * 1000 // in miliseconds

    while(attempt <= max_retries) {
      try{
        let api_url = process.env.VUE_APP_GPATH_LAMBDA_URL.
        api_url = api_url + "/generate_pdf";

        await axios({
          method: "post",
          url: api_url,
          timeout: 1000 * 60 * 5, // Wait for 60*5 seconds
          data: data,
          headers: {
            'Content-Type': 'application/json',
          }
        })

        context.toastMsg = "Report generated successfully"
        context.toastVariant = "success"
        context.showToast = true

        break;
      }
      catch(error){
        attempt++
        await sleep(wait_for * attempt);

        // no need to make retries if the below errors occur
        // if (error.response.status >= 400 && error.response.status < 500 && error.response.status !== 429) {
        //   break;
        // }
      }
    }

    if (attempt >= max_retries) {
      // Display toast message to the users
      console.error("Failed to generate report even after max retries")

      context.toastMsg = "Unable to generate report. Retry after 5 minuites"
      context.toastVariant = "warning"
      context.showToast = true
    }

    /**
     * Internal function that is used to wait before making a retry
     */
    async function sleep(duration) {
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, duration);
      })
    }
  },

   /**
   * gpath_invite
   */
  async gpath_invite (context, gpath_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpath_sessionObj) {
        post_data.append(key, gpath_sessionObj[key]);
      }

      return await request.curl(context, "gpath_invite", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpath_invite() and Exception:',err.message)
    }
  },

  /**
   * gpath_NotesEdit
   */
  async gpathNotesEdit (context, gpath_notesObj) {
    try{
      let post_data = new FormData();
    
      for (let key in gpath_notesObj) {
        post_data.append(key, gpath_notesObj[key]);
      }

      return await request.curl(context,"gpath_notes_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at gpath_notesEdit() and Exception:',err.message)
    }
  }
}

export {
  GPathSessions
}
